<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat profil streamu' | translate" route-name="streamProfileNew"></add-button>
      <h1 v-translate>Profily streamu</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <div class="field_right" v-if="$_loggedUser_action_allowed('codecs')">
          <select-box
              id="codec"
              :options="codecOptions"
              v-model="formFields.codec"
              ref="codecref"
          >
            <translate class="translate">Kodek</translate>
          </select-box>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="stream-profiles">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in streamProfilesTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>

            <stream-profile-row
                v-for="streamProfile in entities"
                :entity="streamProfile"
                :key="streamProfile.id"
                @deleteStreamProfile="deleteEntity"
                :selectedEntities="selectedEntities"
                @input="select"
                :ref="'stream-profile-row-ref-'+streamProfile.id"
            ></stream-profile-row>

            <tr v-if="entities.length === 0">
              <td colspan="8">{{ $gettext('Nebyly nalezeny žádné profily streamu.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="stream-profiles"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          @select-all="toggleSelectAll"
          :multiple-action-options="multipleActionOptions"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import StreamProfileRow from "@/components/views/streamProfiles/StreamProfileRow"
import listActions from "@/components/mixins/list-actions"
import {prependOptions} from "@/utils/helpers";

export default {
  name: "StreamProfiles",
  components: {
    StreamProfileRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'streamProfiles',
      entitiesKey: 'stream_profiles',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        },
        codec: 0
      },
      codecs: []
    }
  },
  created(StreamProfileService, CodecService) {
    this.entityService = StreamProfileService
    this.codecService = CodecService

    if (this.$_loggedUser_action_allowed('codecs', 'read')) {
      this.codecService.getEntities()
          .then((data) => {
            this.codecs = data['codecs']
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    }

    this.createdInit()
  },
  computed: {
    streamProfilesTableTitles() {
      return this.$_readActionAllowedAllOrOwnAndGlobal ? this.ownerTableTitles : this.operatorTableTitles;
    },
    ownerTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název profilu'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Rozlišení'), column: 'sResolution'},
        {key: 4, name: this.$gettext('Bitrate'), column: 'sBitrate'},
        {key: 5, name: this.$gettext('Kodek'), column: 'sCodecName'},
        {key: 6, name: this.$gettext('Synch. sk.'), column: 'sSyncGroup'},
        {key: 7, name: this.$gettext('Videotéka'), column: 'sVod'},
        {key: 8, name: this.$gettext('Operátor'), column: 'sOperatorName'},
        {key: 9, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 10, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ];
    },
    operatorTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název profilu'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Rozlišení'), column: 'sResolution'},
        {key: 4, name: this.$gettext('Bitrate'), column: 'sBitrate'},
        {key: 5, name: this.$gettext('Kodek'), column: 'sCodecName'},
        {key: 6, name: this.$gettext('Synch. sk.'), column: 'sSyncGroup'},
        {key: 7, name: this.$gettext('Videotéka'), column: 'sVod'},
        {key: 8, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 9, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    codecOptions() {
      if (this.codecs) {
        return prependOptions(this._.map(this.codecs, function (item) {
          return {id: item['id'], text: item['name']}
        }), this.$gettext('Všechny'))
      } else {
        return []
      }
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.streamProfilesTableTitles)
      headers.resolution.callback = (entity) => {return entity.resolution.width + 'x' + entity.resolution.height; };

      return headers;
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
        if (message.match("^Unable to delete stream profile - there are (.+) device profiles with given stream profile\.$")) {
          errorMessage = this.$gettext("Profil streamu nelze smazat - existují profily zařízení s tímto profilem.");
        } else {
          errorMessage = message;
        }
      }.bind(this))

      return errorMessage || error['error_message'];
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('codec') && this.formFields.codec !== 0 && this.$_loggedUser_action_allowed('codecs')) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('codec', this.formFields.codec)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/StreamProfilesList.vue